import { tokens } from '@domain-group/fe-brary';
import { mutedButtonStyles } from '../utils';
export default mutedButtonStyles(tokens.colors.secondary);